import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M10 8l2 5l2 -5","key":"svg-1"}],["path",{"d":"M12 16v-3","key":"svg-2"}]]

const IconCircleLetterY = createReactComponent('outline', 'circle-letter-y', 'CircleLetterY', __iconNode);

export default IconCircleLetterY;